import { useRef } from 'react';
import { useTreeStateContext } from '../../../contexts/TreeContext';

const useCanvasState = () => {
    const { blocks: canvasBlocks, categories: canvasCategories } = useTreeStateContext();
    const canvasBlocksRef = useRef(canvasBlocks);
    canvasBlocksRef.current = canvasBlocks;
    const canvasCategoriesRef = useRef(canvasCategories);
    canvasCategoriesRef.current = canvasCategories;
    const existingBlockIds = new Set((canvasBlocks || []).map((block) => block.object_id));

    return { canvasBlocksRef, canvasCategoriesRef, existingBlockIds };
};

export default useCanvasState;
